// extracted by mini-css-extract-plugin
export var root = "F_vF";
export var wrapper = "F_vG";
export var image = "F_vH d_w d_y d_W";
export var imageWithHeight = "F_vJ";
export var crop = "F_vK";
export var round = "F_vL";
export var fixedHeight = "F_vM";